__turbopack_context__.v({
  "favorite-theater-icon": "favorite-theater-icon-module-scss-module__NhLxJG__favorite-theater-icon",
});
